__turbopack_context__.v({
  "discount": "TfvCKq_discount",
  "discount-config": "TfvCKq_discount-config",
  "discount-large": "TfvCKq_discount-large",
  "old-price": "TfvCKq_old-price",
  "subtotal-price": "TfvCKq_subtotal-price",
  "subtotal-price-config-discount": "TfvCKq_subtotal-price-config-discount",
  "subtotal-price-large": "TfvCKq_subtotal-price-large",
  "total-price": "TfvCKq_total-price",
  "total-price-config": "TfvCKq_total-price-config",
  "total-price-large": "TfvCKq_total-price-large",
});
